import {clearClaim, clearDocumentsHistoryQueryResults, clearTobaccoDocumentsHistoryQueryResults, downloadHistoryPdf, editDocumentHistoryQuery, editTobaccoDocumentsHistoryQuery, loadMoreDocumentsHistoryQueryResults, loadMoreTobaccoDocumentsHistoryQueryResults} from "../../actions/history";

import HistoryDocumentsComponent from "../../components/history/HistoryDocumentsComponent.jsx";
import {connect} from "react-redux";
import {createBoundFunction} from "../../../common/util/reselect";
import {createFlowControl} from "../../../common/util/flowControl";
import {createLocalization} from "../../../common/util/localization.jsx";
import {scssVariables} from "../../../common/util/config.jsx";
import {withRouter} from "react-router-dom";

const mapStateToProps = () => {
    const flowControl = createFlowControl();

    return state => ({
        deviceType: state.view.deviceType,
        documentsHistoryQuery: state.history.documents,
        tobaccoDocumentsHistoryQuery: state.history.tobaccoDocuments,
        flowControl: flowControl,
        token: state.authentication.token,
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        localization: createLocalization(state),
        signedInAs: state.authentication.signedInAs
    });
};

const mapDispatchToProps = {
    clearDocumentsHistoryQueryResults,
    clearTobaccoDocumentsHistoryQueryResults,
    downloadHistoryPdf,
    editDocumentHistoryQuery,
    editTobaccoDocumentsHistoryQuery,
    loadMoreDocumentsHistoryQueryResults,
    loadMoreTobaccoDocumentsHistoryQueryResults,
    clearClaim,
};

const myDownloadHistoryPdf = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    downloadHistoryPdf: myDownloadHistoryPdf((resault) => dispatchProps.downloadHistoryPdf(stateProps.token, stateProps.signedInAs, resault)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(HistoryDocumentsComponent));